import React from "react";
import { Container } from "react-bootstrap";

function BlogPage2({ blog }) {
  return (
    <Container>
      <h1>{blog.blogName}</h1>
      <img src={blog.blogImg} alt="a" style={{ width: "30%" }} />
      <p>{blog.blogText}</p>
      <h1>{blog.blogName}</h1>
      {/* Add unique design elements for Blog ID 1 */}
    </Container>
  );
}

export default BlogPage2;